import {
  DeleteMessagePayload,
  EditMessagePayload,
  SOCKET_EVENTS,
  SocketMessage,
  SocketMessageDto,
  SocketUserJoinedDto,
} from "@/types";
import { io, Socket } from "socket.io-client";
import { accessToken } from "./api";

export class SocketManager {
  private socket: Socket | null = null;
  private static instance: SocketManager | null = null;

  private constructor() {}

  // Singleton pattern
  static getInstance(): SocketManager {
    if (!SocketManager.instance) {
      SocketManager.instance = new SocketManager();
    }
    return SocketManager.instance;
  }

  // Connect to server
  connect(): void {
    if (this.socket?.connected) return;

    const url = import.meta.env.VITE_API_SOCKET_URL;
    const token = accessToken; // Assuming you have a global auth token

    // Tạo instance socket và tạo kết nối tới server
    this.socket = io(url, {
      extraHeaders: {
        Authorization: `Bearer ${token}`,
      },
      auth: {
        token: token,
      },
      transports: ["websocket"],
      //   timeout: 20000,
    });

    // Handle default connection events
    this.socket?.on(SOCKET_EVENTS.CONNECT, () => {
      console.log("Socket connected");
    });
    this.socket?.on(SOCKET_EVENTS.DISCONNECT, (reason) => {
      console.log("Socket disconnected:", reason);
    });
    this.socket?.on(SOCKET_EVENTS.ERROR, (error) => {
      console.error("Socket error:", error);
    });
  }

  // Listen for connected event
  onConnect(callback: () => void): void {
    this.socket?.on(SOCKET_EVENTS.CONNECT, callback);
  }

  // Listen for disconnect event
  onDisconnect(callback: (reason: string) => void): void {
    this.socket?.on(SOCKET_EVENTS.DISCONNECT, callback);
  }

  // Listen for error events
  onError(callback: (error: any) => void): void {
    this.socket?.on(SOCKET_EVENTS.ERROR, callback);
  }

  // Listen for join events
  onJoin(callback: (data: any) => void): void {
    this.socket?.on(SOCKET_EVENTS.JOIN_ROOM, callback);
  }

  // Listen for messages
  onMessage(callback: (data: SocketMessageDto) => void): void {
    this.socket?.on(SOCKET_EVENTS.NEW_MESSAGE, callback);
  }

  // Listen for file send events
  onSendFile(callback: (data: any) => void): void {
    this.socket?.on(SOCKET_EVENTS.SEND_FILE, callback);
  }

  // Listen for users joined in room event
  onUserJoined(callback: (data: SocketUserJoinedDto) => void): void {
    this.socket?.on(SOCKET_EVENTS.USER_JOINED, callback);
  }

  // List users_in_room event after emit get users in room
  onUsersInRoom(callback: (data: SocketUserJoinedDto) => void): void {
    this.socket?.on(SOCKET_EVENTS.USERS_IN_ROOM, callback);
  }

  // Listen for message deleted event
  onMessageDeleted(
    callback: (data: { messageId: number; roomId: string }) => void
  ): void {
    this.socket?.on(SOCKET_EVENTS.MESSAGE_DELETED, callback);
  }

  // Listen for message edited event
  onMessageEdited(
    callback: (data: { roomId: string; message: any }) => void
  ): void {
    this.socket?.on(SOCKET_EVENTS.MESSAGE_EDITED, callback);
  }

  // Listen new message in public event
  onPublicMessage(callback: (data: SocketMessageDto) => void): void {
    this.socket?.on(SOCKET_EVENTS.PUBLISH_MESSAGE, callback);
  }

  // Listen for user left event
  onUserLeft(
    callback: (data: [{ email: string; id: number; name: string }]) => void
  ): void {
    this.socket?.on(SOCKET_EVENTS.USER_LEFT, callback);
  }

  // Join room
  joinRoom(roomId: string): void {
    this.socket?.emit(SOCKET_EVENTS.JOIN_ROOM, { roomId });
  }

  // Send message
  emitMessage(data: SocketMessage): void {
    this.socket?.emit(SOCKET_EVENTS.SEND_MESSAGE, data);
  }

  // get list of users in room
  emitGetUsersInRoom({ roomId }: { roomId: string }): void {
    this.socket?.emit(SOCKET_EVENTS.GET_USERS_IN_ROOM, { roomId });
  }

  // emit delete message
  emitDeleteMessage(data: DeleteMessagePayload): void {
    this.socket?.emit(SOCKET_EVENTS.DELETE_MESSAGE, data);
  }

  // emit edit message
  emitEditMessage(data: EditMessagePayload): void {
    this.socket?.emit(SOCKET_EVENTS.EDIT_MESSAGE, data);
  }

  // emit leave room
  emitLeaveRoom(roomId: string): void {
    this.socket?.emit(SOCKET_EVENTS.LEAVE_ROOM, { roomId });
  }

  // Disconnect
  disconnect(): void {
    this.socket?.disconnect();
    this.socket = null;
  }

  // Get socket connection status
  isConnected(): boolean {
    return this.socket?.connected || false;
  }

  // Remove all listeners for a specific event
  off(event: SOCKET_EVENTS): void {
    this.socket?.off(event);
  }
}
